import { CardMedia } from '@mui/material'
import DialogComponent from 'components/DialogComponent'
import React from 'react'

const ImageModal = ({ open, handleClose, fileUrl, title }) => {
    return (
        <DialogComponent
            title={title}
            open={open}
            handleClose={handleClose}
            maxWidth='md'
        >
            <CardMedia
                component="img"
                sx={{ height: "500px", width: "100%", objectFit: "cover" }}
                image={fileUrl || ""}
                alt={"image"}
            />
        </DialogComponent>
    )
}

export default ImageModal
